import { Injectable } from "@angular/core";
import {
	ActivatedRouteSnapshot,
	CanActivate,
	Router,
	RouterStateSnapshot,
	UrlTree,
} from "@angular/router";
import { Observable, from } from "rxjs";
import { mergeMap, map } from "rxjs/operators";
import { AuthService } from "../endpoints/auth.service";
import { ToastService } from "./toast.service";
import { TranslateService } from "@ngx-translate/core";

@Injectable({
	providedIn: "root",
})
export class TokenGuard implements CanActivate {
	constructor(
		private router: Router,
		private toast: ToastService,
		private authService: AuthService
	) {}

	canActivate(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): Observable<boolean | UrlTree> | boolean | UrlTree {
		const isLogged = AuthService.isLogged();
		const isExpired = AuthService.isExpired();

		if (isLogged && isExpired) {
			this.router.navigate(["/login"]);
			this.toast.show("Aviso", "Inicie sesión de nuevo", "warn");
			localStorage.clear();
			sessionStorage.clear();
		}

		if (AuthService.isTimeToRefresh()) {
			return from(
				new Promise<boolean>((resolve) => {
					this.authService.refresh().subscribe({
						next: () => resolve(true),
						error: () => resolve(false),
					});
				})
			);
		}

		if (state.url.includes("/login") && isLogged && !isExpired) {
			this.router.navigate(["app"]);
			return false;
		}

		if (!state.url.includes("/login") && !isLogged) {
			this.router.navigate(["/login"]);
			return false;
		}

		return true;
	}
}
